/**
 * Financial Settings Page
 */
import React from 'react';

const FinancialSettings = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Financial Settings</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Configure financial parameters</p>
    </div>
  );
};

export default FinancialSettings;
